import PublicHttpClient from '../../services/public-http-client';
import { Pagination } from '../../../model/pagination';
import { ITransferPagedRequest } from '../../../model/sge/transfer/request/transfer-paged-request';
import { ITransferResponse } from '../../../model/sge/transfer/response/transfer-response';

const basePath = (clientId: number, amendmentId: number) => `Public/Client/${clientId}/Amendment/${amendmentId}/Transfers`;

const list = async (clientId: number, amendmentId: number, params: Omit<ITransferPagedRequest, 'amendmentId'>): Promise<Pagination<ITransferResponse>> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId, amendmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<ITransferResponse>(), response.data));
};

const PublicTransferAppService = { list };
export default PublicTransferAppService;
